import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

export default class WarehouseDispatchNoSer {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/companyList")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public SearchDecision(querySearch: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/decision-dispatch", querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public excelTlm(querySearch?: any, data?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/decision-dispatch/excel?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch), data, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/phiquyen/get-doc-types?page=0&size=10")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public dispatchNoSer(querySearch?: any, checksms?: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/document/khoso?send_sms=${checksms}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
